import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { DateUtils } from 'bdvp-common/src/utils';

import Input from '@mlb/react-patterns/components/DateInput/dateInput';

const Container = styled.div`
    margin-bottom: 10px;
`;

const DateInput = (props) => {

    const {
        fields,
        onChange,
        className,
        disabled,
    } = props;

    const {
        selected,
        ...field
    } = fields[0];

    const selectedValue = selected[0]?.value;
    const date = selectedValue ? DateUtils.parseTimestampToDate(selectedValue) : null;

    const onBlurHandler = ({ data = {} }) => {

        const {
            valid,
            string,
            date,
        } = data;

        let newSelected = [];
        let event = 'deselect';
        let changes = selected[0];

        if (valid) {

            changes = {
                label: DateUtils.formatDate(date, 'en', 'short'),
                value: string,
            };
            newSelected = [changes];
            event = 'select';

        }

        const normalizedData = {
            changes,
            selected: newSelected,
            event,
        };

        // Let's bail if there are no changes or if there is an internal invalid date message being displayed to the user
        // only an empty invalid date is allowed through
        if (!normalizedData.changes || (!valid && string !== '//')) {

            return;

        }

        onChange(normalizedData, field);

    };

    const onResetClickHandler = () => {

        onChange({
            changes: selected[0],
            selected: [],
            event: 'deselect',
        }, field);

    };


    return (
        <Container className={className}>
            <Input
                value={date}
                handlers={{
                    onBlur: onBlurHandler,
                }}
                minDate={'01/01/1839'}
                resetBtnHandlers={{
                    onClick: onResetClickHandler,
                }}
                disabled={disabled}
                inputFormat={disabled ? '' : undefined}
            />
        </Container>
    );

};

DateInput.propTypes = {
    onChange: PropTypes.func.isRequired,
    fields: PropTypes.arrayOf(
        PropTypes.shape({
            selected: PropTypes.array.isRequired,
        }).isRequired
    ).isRequired,
    disabled: PropTypes.bool,
};

DateInput.defaultProps = {
    disabled: undefined,
};

export default DateInput;
